import {atom} from 'recoil';

export const createProjectDialogOpenState = atom({
  key: 'createProjectDialogOpenState',
  default: false,
});

export const directQuoteDialogOpenState = atom({
  key: 'directQuoteDialogOpenState',
  default: false,
});

export const nonLoggedInUserDialogOpenState = atom({
  key: 'nonLoggedInUserDialogOpenState',
  default: false,
});

export const feedbackDialogOpenState = atom({
  key: 'feedbackDialogOpenState',
  default: false,
});

export const supportPopupOpenState = atom({
  key: 'supportPopupOpenState',
  default: false,
});

export const signUpDialogOpenState = atom({
  key: 'signUpDialogOpenState',
  default: false,
});

export const insuranceDialogOpenState = atom({
  key: 'insuranceDialogOpenState',
  default: false,
});

export const restrictedContentWarningOpenState = atom({
  key: 'restrictedContentWarningOpenState',
  default: false,
});

export const bidmiiProForceUpgradeOpenState = atom({
  key: 'bidmiiProForceUpgradeOpenState',
  default: false,
});
